import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi } from '@/api/ApiContext';
import type { ApiResponse } from '@/api/handlers/responses';
import type { AttributeValue } from '@/api/models';
import { AttributeQueryKeys } from './attributeQueryKeys';

export type PromoteAttributeValueVariables = {
    typeId: string;
    valueId: string;
};

export const usePromoteAttributeValueMutation = () => {
    const { apiClient } = useApi();
    const queryClient = useQueryClient();

    return useMutation<
        ApiResponse<AttributeValue>,
        Error,
        PromoteAttributeValueVariables
    >({
        mutationFn: ({ typeId, valueId }) =>
            apiClient.attributeTypes.promoteValue(typeId, valueId),
        onSuccess: (result) => {
            if (result.success) {
                queryClient.invalidateQueries({
                    queryKey: AttributeQueryKeys.all,
                });
            }
        },
    });
};
